import styled from 'styled-components';
import { Text } from 'shared/components/Text/Text';

export const BodyText = styled(Text)`
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.textSecondaryGrey90};
`;

export const SmsOptInModalBodyContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px 0px 24px 0px;
    width: auto;
    align-self: center;
    @media screen and (min-width: ${theme.breakpoints.small}) {
      padding: 16px 8px 24px 8px;
      width: 100%
    }
`}
`;

export const SmsOptInModalFooterContainer = styled.div`
  ${({ theme }) => `  
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;
    height: 100%;
    gap: 24px;
    align-self: stretch;
    padding-top: 20px;
    @media screen and (min-width: ${theme.breakpoints.small}) {
        height: auto;
        align-items: center;
    }
`}
`;
